import {
  buildAdminListQuery,
  type TAdminListParams,
} from '@/core/lib/table-query'

export const avatarEndpoints = {
  list: (params: TAdminListParams) =>
    `/admin/avatars?${buildAdminListQuery(params)}`, // GET
  presign: '/admin/avatars/presign', // POST (D6: get S3 PUT url)
  finalize: '/admin/avatars/finalize', // POST (D6: register uploaded key)
  detail: (id: string) => `/admin/avatars/${id}`, // GET
  edit: (id: string) => `/admin/avatars/${id}`, // PATCH (name? + presigned key?)
  delete: (id: string) => `/admin/avatars/${id}`, // DELETE
}

export const avatarBackendErrors = {
  AVATAR_NOT_FOUND: 'Avatar bulunamadı!',
  AVATAR_EXISTS: 'Bu avatar çoktan oluşturulmuş!',
  AVATAR_CREATE: 'Avatar oluşturulurken hata oluştu!',
  AVATAR_EDIT: 'Avatar düzenlenirken hata oluştu!',
  AVATAR_DELETE: 'Avatar silinirken hata oluştu!',
  GENERAL_ERROR: 'Beklenemeyen bir hata oluştu!',
}

export const avatarSuccessMessages = {
  avatarCreate: 'Avatar başarıyla oluşturuldu!',
  avatarEdit: 'Avatar başarıyla düzenlendi!',
  avatarDelete: 'Avatar başarıyla silindi!',
}
